import type { components } from '@shared/types/generated/Crocotile.ts';
import type { Variation, VariationV2 } from '@shared/types/types.ts';
import type { ProductTitle } from '@tile/components/product-title/ProductTitle.ts';

type Title = components['schemas']['Title'] | undefined;

/*                                                                                                 */
export function mapTitle(variation: Variation | VariationV2, hasTopInfos: boolean): ProductTitle {
    return {
        brand: variation.brand,
        display: resolveDisplayTitle(variation.title, hasTopInfos),
    };
}

/*                                                                         */
export function mapFashionTitle(variation: Variation | VariationV2): ProductTitle {
    return {
        brand: variation.brand,
        display: variation.title?.withoutBrand ?? '',
    };
}

/**
 *
 *
 */
export function mapShortTitle(variation: Variation | VariationV2): ProductTitle {
    return {
        brand: variation.brand,
        display: resolveDisplayTitle(variation.title, true),
    };
}

/**
 *
 *
 *
 *
 *
 *
 *
 */
function resolveDisplayTitle(title: Title, hasTopInfos = false) {
    if (!title) return '';
    if (hasTopInfos && title.shortened) return title.shortened;
    return title.withoutBrand ?? '';
}
